import { Navigate, createBrowserRouter } from "react-router-dom";
import App from "../App";
import ROUTES from "./routes";
// Components
import Layout from "../components/global/Layout";
// Pages
import Login from "../pages/Login/Login";
import Dasboard from "../pages/Dasboard/Dasboard";
import RolesList from "../pages/Roles/List";
import GamesList from "../pages/GameCenter/Games/List";
import CollectionsList from "../pages/GameCenter/Collections/List";
import MultiScopeList from "../pages/GameCenter/MultiScope/List";
import CategoriesList from "../pages/GameCenter/Categories/List";
import TagsList from "../pages/GameCenter/Tags/List";
import ProvidersList from "../pages/GameCenter/Providers/List";
import ParsingList from "../pages/GameCenter/Parsing/List";
import MainPage from "../pages/CMS/Widgets/MainPage";
import BurgerMenu from "../pages/CMS/Widgets/BurgerMenu";
import MobileMenu from "../pages/CMS/Widgets/MobileMenu";
import SignUpForm from "../pages/CMS/Widgets/SignUpForm";
import PreDepositForm from "../pages/CMS/Widgets/PreDepositForm";
import ProfileMenu from "../pages/CMS/Widgets/ProfileMenu";
import SegmentsList from "../pages/Players/Segments/List";
import PlayersList from "../pages/Players/List/List";
import WagersList from "../pages/LiveOps/WagerGames/List";
import GamesListWager from "../pages/LiveOps/WagerGames/NotProcessing";
import BonusesList from "../pages/LiveOps/Bonuses/List";
import FreeSpins from "../pages/LiveOps/Bonuses/FreeSpins";
import PushList from "../pages/Notifications/Push/List";
import EmailsList from "../pages/Notifications/Email/List";
import LevelsList from "../pages/LiveOps/LoyaltyProgram/Levels/LevelsList";
import BetPointsList from "../pages/LiveOps/LoyaltyProgram/BetsPoints/BetPointsList";
import DepositPointsList from "../pages/LiveOps/LoyaltyProgram/DepositPoints/DepositPointsList";
import DepositPointsLimitsList from "../pages/LiveOps/LoyaltyProgram/DepositPointsLimits/DepositPointsLimitsList";
import SignUpPointsList from "../pages/LiveOps/LoyaltyProgram/SignUpPoints/SignUpPointsList";
import BannersList from "../pages/CMS/Banners/List";
import PaymentProvidersList from "../pages/Payments/PSP/Providers/List";
import PaymentMethodsList from "../pages/Payments/PSP/Methods/List";
import DepositsList from "../pages/Payments/Transactions/Deposits/List";
import Withdrawals from "../pages/Payments/Transactions/Withdrawals/List";
import OperationsList from "../pages/Payments/Transactions/Operations/List";
import CompensationsList from "../pages/Payments/Transactions/Compensations/List";
import ConfiscationsList from "../pages/Payments/Transactions/Confiscations/List";
import CurrenciesList from "../pages/Payments/Currencies/List";
import LogsList from "../pages/Logs/List";
import CashbacksList from "../pages/LiveOps/Cashbacks/List";
import TournamentsList from "../pages/LiveOps/Tournaments/List";
import PromocodesList from "../pages/LiveOps/Promocodes/List";
import AnalyticCommonList from "../pages/Analytic/Global/Common/List";
import AnalyticPaymentMethodsList from "../pages/Analytic/Payments/Methods/List";
import AnalyticPaymentProvidersList from "../pages/Analytic/Payments/Providers/List";
import AnalyticPaymentDepositsList from "../pages/Analytic/Payments/Deposits/List";
import PagesList from "../pages/CMS/Pages/List/List";
import SeoList from "../pages/CMS/Pages/SEO/List";
import FaqList from "../pages/CMS/Pages/FAQ/List";
import CashbackGamesList from "../pages/LiveOps/CashbackGames/List";
import CashbackGamesListGames from "../pages/LiveOps/CashbackGames/NotProcessing";
import AnalyticGamesList from "../pages/Analytic/Casino/Games/List";
import AnalyticProvidersList from "../pages/Analytic/Casino/Providers/List";
import PromoList from "../pages/CMS/Promo/List";
import Header from "../pages/CMS/Widgets/Header";
import GameBar from "pages/CMS/Widgets/GameBar";
import Footer from "../pages/CMS/Widgets/Footer";
import ZonesList from "../pages/Domains/Zones/List";
import MirrorList from "pages/Domains/Mirrors/List";
import CountriesList from "pages/Domains/Countries/List";
import PartnersList from "pages/CMS/Footer/Partners/List";
import SocialNetworksList from "pages/CMS/Footer/SocialNetworks/List";
import ApplicationsList from "pages/CMS/Footer/Applications/List";
import MainTexList from "pages/CMS/Footer/MainText/List";
import PaymentsList from "pages/CMS/Footer/Payments/List";
import BrandCoreList from "pages/CMS/Footer/BrandCore/List";
import AnalyticSportsCategoriesList from "pages/Analytic/Sports/Categories/List";
import AnalyticSportsCompetitionsList from "pages/Analytic/Sports/Competitions/List";
import TreadsList from "pages/Support/Threads/List";
import ChannelsList from "pages/Support/Channels/List";
import RiskPermissionsList from "pages/Risk/Permissions/List";
import RiskLimitsList from "pages/Risk/Limits/List";
import RiskPlayersList from "pages/Risk/Players/List";
import RiskKycDocumentsList from "pages/Risk/Kyc/Documents/List";
import RiskKycPresetsList from "pages/Risk/Kyc/Presets/List";
import RiskKycRulesList from "pages/Risk/Kyc/Rules/List";
import CustomizedList from "pages/CMS/Customized/List";
import PresetsList from "pages/Players/Presets/List";
import WagerPointsList from "pages/LiveOps/LoyaltyProgram/WagerPoints/WagerPointsList";
import CasinoPage from "pages/CMS/Widgets/CasinoPage";
import LiveCasinoPage from "pages/CMS/Widgets/LiveCasinoPage";
import SchedulerList from "pages/Scheduler/List";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      {
        path: ROUTES.LOGIN,
        Component: Login,
      },
      // Analytic
      {
        path: ROUTES.ANALYTIC_GLOBAL_COMMON,
        element: (
          <Layout>
            <AnalyticCommonList />
          </Layout>
        ),
      },
      {
        path: ROUTES.ANALYTIC_SPORTS_CATEGORIES,
        element: (
          <Layout>
            <AnalyticSportsCategoriesList />
          </Layout>
        ),
      },
      {
        path: ROUTES.ANALYTIC_SPORTS_COMPETITIONS,
        element: (
          <Layout>
            <AnalyticSportsCompetitionsList />
          </Layout>
        ),
      },
      {
        path: ROUTES.ANALYTIC_PAYMENTS_METHODS,
        element: (
          <Layout>
            <AnalyticPaymentMethodsList />
          </Layout>
        ),
      },
      {
        path: ROUTES.ANALYTIC_PAYMENTS_PROVIDERS,
        element: (
          <Layout>
            <AnalyticPaymentProvidersList />
          </Layout>
        ),
      },
      {
        path: ROUTES.ANALYTIC_PAYMENTS_DEPOSITS,
        element: (
          <Layout>
            <AnalyticPaymentDepositsList />
          </Layout>
        ),
      },
      {
        path: ROUTES.ANALYTIC_GAMES,
        element: (
          <Layout>
            <AnalyticGamesList />
          </Layout>
        ),
      },
      {
        path: ROUTES.ANALYTIC_PROVIDERS,
        element: (
          <Layout>
            <AnalyticProvidersList />
          </Layout>
        ),
      },
      // Logs
      {
        path: ROUTES.LOGS_LIST_ERROR,
        element: (
          <Layout>
            <LogsList />
          </Layout>
        ),
      },
      {
        path: ROUTES.LOGS_LIST_NOTICE,
        element: (
          <Layout>
            <LogsList />
          </Layout>
        ),
      },
      {
        path: ROUTES.LOGS_LIST_WARNINGS,
        element: (
          <Layout>
            <LogsList />
          </Layout>
        ),
      },
      // Risk
      {
        path: ROUTES.RISK_LIST_PLAYERS,
        element: (
          <Layout>
            <RiskPlayersList />
          </Layout>
        ),
      },
      {
        path: ROUTES.RISK_LIST_KYC_DOCUMENTS,
        element: (
          <Layout>
            <RiskKycDocumentsList />
          </Layout>
        ),
      },
      {
        path: ROUTES.RISK_LIST_PERMISSIONS,
        element: (
          <Layout>
            <RiskPermissionsList />
          </Layout>
        ),
      },
      {
        path: ROUTES.RISK_LIST_LIMITS,
        element: (
          <Layout>
            <RiskLimitsList />
          </Layout>
        ),
      },
      {
        path: ROUTES.RISK_LIST_KYC_PRESETS,
        element: (
          <Layout>
            <RiskKycPresetsList />
          </Layout>
        ),
      },
      {
        path: ROUTES.RISK_LIST_KYC_RULES,
        element: (
          <Layout>
            <RiskKycRulesList />
          </Layout>
        ),
      },
      // Game center
      {
        path: ROUTES.GAME_CENTER_GAMES_LIST_NEW,
        element: (
          <Layout>
            <GamesList />
          </Layout>
        ),
      },
      {
        path: ROUTES.GAME_CENTER_GAMES_LIST_ACTIVE,
        element: (
          <Layout>
            <GamesList />
          </Layout>
        ),
      },
      {
        path: ROUTES.GAME_CENTER_GAMES_LIST_HIDDEN,
        element: (
          <Layout>
            <GamesList />
          </Layout>
        ),
      },
      {
        path: ROUTES.GAME_CENTER_GAMES_LIST_DEACTIVETED,
        element: (
          <Layout>
            <GamesList />
          </Layout>
        ),
      },
      {
        path: ROUTES.GAME_CENTER_GAMES_LIST_NO_CATEGORY,
        element: (
          <Layout>
            <GamesList />
          </Layout>
        ),
      },
      {
        path: ROUTES.GAME_CENTER_COLLECTIONS_LIST,
        element: (
          <Layout>
            <CollectionsList />
          </Layout>
        ),
      },
      {
        path: ROUTES.GAME_CENTER_MULTI_SCOPE_LIST,
        element: (
          <Layout>
            <MultiScopeList />
          </Layout>
        ),
      },
      {
        path: ROUTES.GAME_CENTER_CATEGORIES_LIST,
        element: (
          <Layout>
            <CategoriesList />
          </Layout>
        ),
      },
      {
        path: ROUTES.GAME_CENTER_TAGS_LIST,
        element: (
          <Layout>
            <TagsList />
          </Layout>
        ),
      },
      {
        path: ROUTES.GAME_CENTER_PROVIDERS_LIST,
        element: (
          <Layout>
            <ProvidersList />
          </Layout>
        ),
      },
      {
        path: ROUTES.GAME_CENTER_PARSING,
        element: (
          <Layout>
            <ParsingList />
          </Layout>
        ),
      },
      // Roles
      {
        path: ROUTES.ROLES_LIST,
        element: (
          <Layout>
            <RolesList />
          </Layout>
        ),
      },
      // CMS
      {
        path: ROUTES.CMS_PROMO_LIST,
        element: (
          <Layout>
            <PromoList />
          </Layout>
        ),
      },
      {
        path: ROUTES.CMS_WIDGETS_MAIN_PAGE,
        element: (
          <Layout>
            <MainPage />
          </Layout>
        ),
      },
      {
        path: ROUTES.CMS_WIDGETS_CASINO_PAGE,
        element: (
          <Layout>
            <CasinoPage />
          </Layout>
        ),
      },
      {
        path: ROUTES.CMS_WIDGETS_LIVE_CASINO_PAGE,
        element: (
          <Layout>
            <LiveCasinoPage />
          </Layout>
        ),
      },
      {
        path: ROUTES.CMS_WIDGETS_BURGER_MENU,
        element: (
          <Layout>
            <BurgerMenu />
          </Layout>
        ),
      },
      {
        path: ROUTES.CMS_WIDGETS_MOBILE_MENU,
        element: (
          <Layout>
            <MobileMenu />
          </Layout>
        ),
      },
      {
        path: ROUTES.CMS_WIDGETS_GAME_BAR,
        element: (
          <Layout>
            <GameBar />
          </Layout>
        ),
      },
      {
        path: ROUTES.CMS_WIDGETS_SIGN_UP,
        element: (
          <Layout>
            <SignUpForm />
          </Layout>
        ),
      },
      {
        path: ROUTES.CMS_WIDGETS_PRE_DEPOSIT_FORM,
        element: (
          <Layout>
            <PreDepositForm />
          </Layout>
        ),
      },
      {
        path: ROUTES.CMS_WIDGETS_PROFILE_MENU,
        element: (
          <Layout>
            <ProfileMenu />
          </Layout>
        ),
      },
      {
        path: ROUTES.CMS_BANNERS_LIST,
        element: (
          <Layout>
            <BannersList />
          </Layout>
        ),
      },
      {
        path: ROUTES.CMS_PAGES_LIST,
        element: (
          <Layout>
            <PagesList />
          </Layout>
        ),
      },
      {
        path: ROUTES.CMS_PAGES_SEO,
        element: (
          <Layout>
            <SeoList />
          </Layout>
        ),
      },
      {
        path: ROUTES.CMS_PAGES_FAQ,
        element: (
          <Layout>
            <FaqList />
          </Layout>
        ),
      },
      {
        path: ROUTES.CMS_WIDGETS_HEADER,
        element: (
          <Layout>
            <Header />
          </Layout>
        ),
      },
      {
        path: ROUTES.CMS_WIDGETS_FOOTER,
        element: (
          <Layout>
            <Footer />
          </Layout>
        ),
      },
      {
        path: ROUTES.CMS_FOOTER_PARTNERS,
        element: (
          <Layout>
            <PartnersList />
          </Layout>
        ),
      },
      {
        path: ROUTES.CMS_FOOTER_SOCIAL_NETWORKS,
        element: (
          <Layout>
            <SocialNetworksList />
          </Layout>
        ),
      },
      {
        path: ROUTES.CMS_FOOTER_APPLICATIONS,
        element: (
          <Layout>
            <ApplicationsList />
          </Layout>
        ),
      },
      {
        path: ROUTES.CMS_FOOTER_MAIN_TEXT,
        element: (
          <Layout>
            <MainTexList />
          </Layout>
        ),
      },
      {
        path: ROUTES.CMS_FOOTER_PAYMENTS,
        element: (
          <Layout>
            <PaymentsList />
          </Layout>
        ),
      },
      {
        path: ROUTES.CMS_FOOTER_BRANDCORE,
        element: (
          <Layout>
            <BrandCoreList />
          </Layout>
        ),
      },
      {
        path: ROUTES.CMS_CUSTOMIZED_LIST,
        element: (
          <Layout>
            <CustomizedList />
          </Layout>
        ),
      },
      // Segments
      {
        path: ROUTES.SEGMENTS_AUTO,
        element: (
          <Layout>
            <SegmentsList />
          </Layout>
        ),
      },
      {
        path: ROUTES.SEGMENTS_MANUAL,
        element: (
          <Layout>
            <SegmentsList />
          </Layout>
        ),
      },
      // Players
      {
        path: ROUTES.PLAYERS_LIST,
        element: (
          <Layout>
            <PlayersList />
          </Layout>
        ),
      },
      {
        path: ROUTES.PRESETS_LIST,
        element: (
          <Layout>
            <PresetsList />
          </Layout>
        ),
      },
      // Live ops
      {
        path: ROUTES.WAGERS_LIST,
        element: (
          <Layout>
            <WagersList />
          </Layout>
        ),
      },
      {
        path: ROUTES.WAGERS_GAMES_LIST,
        element: (
          <Layout>
            <GamesListWager />
          </Layout>
        ),
      },
      {
        path: ROUTES.BONUSES_LIST,
        element: (
          <Layout>
            <BonusesList />
          </Layout>
        ),
      },
      {
        path: ROUTES.BONUSES_GAMES_LIST,
        element: (
          <Layout>
            <FreeSpins />
          </Layout>
        ),
      },
      {
        path: ROUTES.LOYALTY_LEVELS_LIST,
        element: (
          <Layout>
            <LevelsList />
          </Layout>
        ),
      },
      {
        path: ROUTES.LOYALTY_BETS_POINTS_LIST,
        element: (
          <Layout>
            <BetPointsList />
          </Layout>
        ),
      },
      {
        path: ROUTES.LOYALTY_WAGER_POINTS_LIST,
        element: (
          <Layout>
            <WagerPointsList />
          </Layout>
        ),
      },
      {
        path: ROUTES.LOYALTY_DEPOSIT_POINTS_LIST,
        element: (
          <Layout>
            <DepositPointsList />
          </Layout>
        ),
      },
      {
        path: ROUTES.LOYALTY_DEPOSIT_POINTS_LIMITS_LIST,
        element: (
          <Layout>
            <DepositPointsLimitsList />
          </Layout>
        ),
      },
      {
        path: ROUTES.LOYALTY_SIGN_UP_POINTS_LIST,
        element: (
          <Layout>
            <SignUpPointsList />
          </Layout>
        ),
      },
      {
        path: ROUTES.CASHBACKS_LIST,
        element: (
          <Layout>
            <CashbacksList />
          </Layout>
        ),
      },
      {
        path: ROUTES.TOURNAMENTS_LIST,
        element: (
          <Layout>
            <TournamentsList />
          </Layout>
        ),
      },
      {
        path: ROUTES.PROMOCODES_BONUSES_LIST,
        element: (
          <Layout>
            <PromocodesList />
          </Layout>
        ),
      },
      {
        path: ROUTES.CASHBACK_GAMES_LIST,
        element: (
          <Layout>
            <CashbackGamesList />
          </Layout>
        ),
      },
      {
        path: ROUTES.CASHBACK_GAMES_LIST_GAMES,
        element: (
          <Layout>
            <CashbackGamesListGames />
          </Layout>
        ),
      },
      // Notifications
      {
        path: ROUTES.NOTIFICATIONS_PUSH_AUTO,
        element: (
          <Layout>
            <PushList />
          </Layout>
        ),
      },
      {
        path: ROUTES.NOTIFICATIONS_PUSH_MANUAL,
        element: (
          <Layout>
            <PushList />
          </Layout>
        ),
      },
      {
        path: ROUTES.NOTIFICATIONS_EMAIL_AUTO,
        element: (
          <Layout>
            <EmailsList />
          </Layout>
        ),
      },
      // Payments
      {
        path: ROUTES.PAYMENT_PROVIDERS,
        element: (
          <Layout>
            <PaymentProvidersList />
          </Layout>
        ),
      },
      {
        path: ROUTES.PAYMENT_METHODS,
        element: (
          <Layout>
            <PaymentMethodsList />
          </Layout>
        ),
      },
      {
        path: ROUTES.PAYMENT_DEPOSITS,
        element: (
          <Layout>
            <DepositsList />
          </Layout>
        ),
      },
      {
        path: ROUTES.PAYMENT_WITHDRAWALS,
        element: (
          <Layout>
            <Withdrawals />
          </Layout>
        ),
      },
      {
        path: ROUTES.PAYMENT_OPERATIONS,
        element: (
          <Layout>
            <OperationsList />
          </Layout>
        ),
      },
      {
        path: ROUTES.PAYMENT_COMPENSATIONS,
        element: (
          <Layout>
            <CompensationsList />
          </Layout>
        ),
      },
      {
        path: ROUTES.PAYMENT_COMPENSATION,
        element: (
          <Layout>
            <CompensationsList />
          </Layout>
        ),
      },
      {
        path: ROUTES.PAYMENT_CONFISCATIONS,
        element: (
          <Layout>
            <ConfiscationsList />
          </Layout>
        ),
      },
      {
        path: ROUTES.PAYMENT_CONFISCATION,
        element: (
          <Layout>
            <ConfiscationsList />
          </Layout>
        ),
      },
      {
        path: ROUTES.PAYMENT_CURRENCIES,
        element: (
          <Layout>
            <CurrenciesList />
          </Layout>
        ),
      },
      {
        path: ROUTES.DOMAINS_ZONES,
        element: (
          <Layout>
            <ZonesList />
          </Layout>
        ),
      },
      {
        path: ROUTES.DOMAINS_MIRRORS,
        element: (
          <Layout>
            <MirrorList />
          </Layout>
        ),
      },
      {
        path: ROUTES.DOMAINS_COUNTRIES,
        element: (
          <Layout>
            <CountriesList />
          </Layout>
        ),
      },
      // Def
      {
        path: ROUTES.DASHBOARD,
        element: (
          <Layout>
            <Dasboard />
          </Layout>
        ),
      },
      {
        path: ROUTES.SUPPORT_TREADS,
        element: (
          <Layout>
            <TreadsList />
          </Layout>
        ),
      },
      {
        path: ROUTES.SUPPORT_CHANNELS,
        element: (
          <Layout>
            <ChannelsList />
          </Layout>
        ),
      },
      {
        path: ROUTES.SCHEDULER_LIST,
        element: (
          <Layout>
            <SchedulerList />
          </Layout>
        )
      },
      {
        path: "/",
        element: (
          <Layout>
            <Dasboard />
          </Layout>
        ),
      },
    ],
  },
  {
    path: "*",
    element: <Navigate to={`${ROUTES.DASHBOARD}`} />,
  },
]);
